/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS')
  .component('zcsChartArea', {
    template: '',
    bindings: {
      chartData: '<'
    },
    controller: zcsChartAreaController
  });

zcsChartAreaController.$inject = ['$element', '$translate'];
function zcsChartAreaController($element, $translate) {
  const vm = this;

  vm.$onChanges = () => {
    // Create a container for the chart
    $element.html('');
    const svgContainer = d3.select($element[0]).append('svg');

    // Draw a line chart
    nv.addGraph(() => {
      let chart = nv.models.stackedAreaChart()
        .margin({top: 8, right: 8, bottom: 8, left: 8}) // fix chart position
        .interpolate('cardinal') // rounded line
        // .showXAxis(false)
        .showLegend(false)
        .showYAxis(false)
        .showControls(false)
        .duration(500)
        .color([angular.element('zcs-chart-area').css('color')])
        .x(d => moment(d.x).valueOf());

      chart.xAxis
        .tickFormat(x => d3.time.format($translate.instant('sharedModules.dateTimeFormats.yearMonthDay'))(moment(x).toDate()));

      svgContainer.datum(vm.chartData)
        .transition()
        .duration(500)
        .call(chart);

      nv.utils.windowResize(chart.update);

      return chart;
    });
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/charts/chart_area.js